import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [message, setMessage] = useState('');

  // Don't show if user is verified or not logged in
  if (!user || user.emailVerified) {
    return null;
  }

  const handleResend = async () => {
    setIsResending(true);
    setMessage('');

    try {
      await api.post('/auth/resend-verification', { email: user.email });
      setMessage('Verification email sent! Check your inbox.');
    } catch {
      setMessage('Failed to send email. Please try again.');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="bg-yellow-900/50 border-b border-yellow-800">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span className="text-yellow-200 text-sm">
              Please verify your email address to access all features.
            </span>
          </div>
          <div className="flex items-center gap-3">
            {message && (
              <span className="text-yellow-300 text-sm">{message}</span>
            )}
            <button
              onClick={handleResend}
              disabled={isResending}
              className="text-sm text-yellow-100 hover:text-white underline disabled:opacity-50"
            >
              {isResending ? 'Sending...' : 'Resend verification email'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
